import { JetView, plugins } from 'webix-jet';

/**
 * Class representing a configuration machine register view.
 * @extends JetView
 */
export default class configurationMachineRegister extends JetView {
    /**
     * Defines the layout configuration for the view.
     * @returns {Object} The layout configuration object.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        return {
            type: 'wide',
            cols: [
                {
                    localId: 'inner:layout', // Unique identifier for the layout
                    type: 'wide',
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Unique identifier for the tab bar
                            height: 43, // Height of the tab bar
                            options: [
                                {
                                    id: 'machine.configuration.securityChanges', // Tab ID
                                    value: _('Seguridad Cambios'), // Tab label with localization
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
